// Чип-фильтр с выпадающим списком значений: FilterButton (пунктирная рамка)
// + DropList/DropListItem + Checkbox из sputnik-ui, число устройств справа.
// Переиспользуемый: новая главная (business_apps#1486), дальше — раздел камер;
// кандидат в sputnik-ui после второго применения.

import React, { useCallback, useRef, useState } from 'react'
import styled from 'styled-components'
import { Typography } from '@material-ui/core'
import { ArrowDropDown } from '@material-ui/icons'
import { Checkbox, DropList, DropListItem } from 'sputnik-ui'
import FilterButton from 'components/atoms/FilterButton'

const Anchor = styled.span`
  display: inline-flex;
`

const Option = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 240px;
  padding-left: ${(p) => (p.$nested ? '24px' : 0)};
`

const Count = styled(Typography)`
  && {
    margin-left: auto;
    padding-left: 16px;
  }
`

const styles = {
  caret: { width: 18, height: 18, marginLeft: 2, marginRight: -4 },
  checkbox: { margin: 0, padding: 0, pointerEvents: 'none' },
}

const hasCount = (value) => value !== undefined && value !== null

export function FilterChipMenu({
  label,
  selectionLabel = '',
  options = [],
  selected = [],
  onChange,
  onOpen,
  multiple = true,
  color = 'lightblue',
}) {
  const anchorRef = useRef(null)
  const menuRef = useRef(null)
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
    if (onOpen) onOpen()
  }

  // DropList закрывается по любому клику в документе; клики внутри списка
  // при множественном выборе оставляем — можно отметить несколько значений.
  const close = useCallback(
    (event) => {
      if (
        multiple &&
        event?.target &&
        menuRef.current?.contains(event.target)
      ) {
        return
      }
      setOpen(false)
    },
    [multiple]
  )

  const toggle = (key) => {
    const isSelected = selected.includes(key)
    let next
    if (multiple) {
      next = isSelected
        ? selected.filter((value) => value !== key)
        : [...selected, key]
    } else {
      next = isSelected ? [] : [key]
    }
    onChange(next)
    if (!multiple) setOpen(false)
  }

  return (
    <>
      <Anchor ref={anchorRef}>
        <FilterButton
          selected={selected.length > 0}
          color={color}
          onClick={handleOpen}
        >
          {label}
          {selectionLabel ? ` ${selectionLabel}` : ''}
          <ArrowDropDown style={styles.caret} />
        </FilterButton>
      </Anchor>
      <DropList
        open={open}
        close={close}
        // Esc и клик по фону — через onClose меню MUI
        onClose={() => setOpen(false)}
        anchorEl={anchorRef.current}
        getContentAnchorEl={null}
      >
        <div ref={menuRef}>
          {options.map((option) => (
            <DropListItem
              key={option.key}
              onClick={() => toggle(option.key)}
              label={
                <Option $nested={Boolean(option.nested)}>
                  <Checkbox
                    checked={selected.includes(option.key)}
                    color="blue"
                    style={styles.checkbox}
                  />
                  <span>{option.label}</span>
                  {hasCount(option.count) && (
                    <Count component="span" color="textSecondary">
                      {option.count}
                    </Count>
                  )}
                </Option>
              }
            />
          ))}
        </div>
      </DropList>
    </>
  )
}

export default FilterChipMenu
